import React from "react";

// Einmal in App.js einbinden. Inline-Styles können kein :focus-visible /
// keine Keyframes — diese wenigen globalen Regeln schließen die Lücke.
const css = `
  /* Sichtbarer Tastatur-Fokus (WCAG 2.4.7 / 1.4.11). Zweifarbig: dunkelgrüner Rahmen
     + gelber Schein → auf hellem UND dunklem Hintergrund ≥ 3:1. !important ist nötig,
     weil viele Komponenten inline "outline: none" setzen (Inline-Styles schlagen sonst
     jede Klasse). Greift nur bei :focus-visible, also nicht beim Mausklick. */
  :root { --aof-focus-ring: #0a3317; --aof-focus-glow: #f5c800; }
  [data-theme="dark"] { --aof-focus-ring: #f5c800; --aof-focus-glow: #0a3317; }
  a:focus-visible, button:focus-visible, summary:focus-visible,
  [role="button"]:focus-visible, [role="tab"]:focus-visible, [tabindex]:focus-visible,
  .aof-focusable:focus-visible {
    outline: 3px solid var(--aof-focus-ring) !important;
    outline-offset: 2px !important;
    box-shadow: 0 0 0 6px var(--aof-focus-glow) !important;
  }
  input:focus-visible, select:focus-visible, textarea:focus-visible {
    outline: 2px solid var(--aof-focus-ring) !important;
    outline-offset: 1px !important;
  }
  .aof-focusable:focus:not(:focus-visible) {
    outline: none;
  }
  /* Endlos-Animationen außerhalb des Viewports anhalten (siehe PauseWhenOffscreen.js) */
  [data-aof-offscreen="true"], [data-aof-offscreen="true"] *,
  [data-aof-offscreen="true"] *::before, [data-aof-offscreen="true"] *::after {
    animation-play-state: paused !important;
  }
  @keyframes aof-skeleton {
    0%   { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }
  @keyframes aof-toast-in {
    0%   { opacity: 0; transform: translate(-50%, 12px); }
    100% { opacity: 1; transform: translate(-50%, 0); }
  }
  .aof-skeleton {
    background: linear-gradient(90deg, #f3eeda 25%, #faf6e8 50%, #f3eeda 75%);
    background-size: 200% 100%;
    animation: aof-skeleton 1.4s ease infinite;
  }
  @media (prefers-reduced-motion: reduce) {
    .aof-skeleton { animation: none; }
    /* Systemeinstellung "Bewegung reduzieren" respektieren (Username-Effekte wie
       glitch/rainbow, Toasts, Hero). Spiele laufen über Canvas/requestAnimationFrame
       und sind davon nicht betroffen. */
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }
`;

export default function UiGlobalStyles() {
  return <style>{css}</style>;
}
